import { DT_BOX_AS_VALUES as e, DT_BOX_BORDER_COLOR_VALUES as t, DT_BOX_BORDER_RADIUS_VALUES as n, DT_BOX_BORDER_WIDTH_VALUES as r, DT_BOX_LAYOUT_VALUES as i, DT_BOX_OVERFLOW_VALUES as a, DT_BOX_SCROLLBAR_VALUES as o, DT_BOX_SHADOW_VALUES as s, DT_BOX_SPACING_VALUES as c, DT_BOX_SURFACE_VALUES as l } from "./box-constants.js";
//#region components/box/validators.js
function u(e, t = []) {
	return (n) => {
		if (t.includes(n) || e.includes(String(n))) return !0;
		if (process.env.NODE_ENV !== "production") {
			let r = [...t.map(String), ...e].join(", ");
			console.warn(`[DtBox] Invalid prop value: "${n}". Valid values: ${r}`);
		}
		return !1;
	};
}
var d = u(e), f = u(c), p = u(l), m = u(t), h = u(r), g = u(n), _ = u(s), v = u(i), y = u(a), b = u(o, [!0]);
//#endregion
export { d as asValidator, m as borderColorValidator, g as borderRadiusValidator, h as borderWidthValidator, v as layoutValidator, y as overflowValidator, b as scrollbarValidator, _ as shadowValidator, f as spacingValidator, p as surfaceValidator };

//# sourceMappingURL=validators.js.map